import { ActionTree } from "vuex";
import { YearmonthState } from "./types";
import { RootState } from "@/store/types";

export const actions: ActionTree<YearmonthState, RootState> = {};
